import { render, staticRenderFns } from "./HostingHistory.vue?vue&type=template&id=540ac41a&scoped=true&"
import script from "./HostingHistory.vue?vue&type=script&lang=js&"
export * from "./HostingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ac41a",
  null
  
)

export default component.exports